//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import immsg from "./imMsg/index";
import doctorDetails from "./../doctorDetails/index";
import caseList from "./../caseList/index";

export default {
  name: "im",
  created() {},
  data() {
    return {
      tabMenu: [
        {
          name: "医生详情",
          src: "doctorDetails"
        },
        {
          name: "线上问诊",
          src: "immsg"
        },
        {
          name: "我的病历",
          src: "caseList"
        }
      ],
      tabIndex: this.$store.state.tabIndex,
      state: 1,
      d: '',
      h: '',
      m: '',
      s: '',
      isShow:'',
      messages:{}
    };
  },
  mounted() {
    document.title = this.$store.state.AllOfValue.ImDoctorInfo.doctorName?this.$store.state.AllOfValue.ImDoctorInfo.doctorName+"医生的对话":"复诊医生";
    this.countTime();

    },
  components: {
    immsg,
    doctorDetails,
    caseList
  },
  methods: {
    //获取医生患者聊天次数
    getChatCounts() {
      if(this.$store.state.AllOfValue.ImDoctorInfo.orderid){
        var _this = this;
        var data = {
          doctorId: this.$store.state.AllOfValue.ImDoctorInfo.doctorId,
          patientId: this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientId,
          orderId: this.$store.state.AllOfValue.ImDoctorInfo.orderid
        };
        this.$doRequest("/api/giveTalk/getSurplusTalkNum", data, res => {
          _this.lastNum=res.parameters.lastNum;
          this.$store.state.lastNum=res.parameters.lastNum;
        });
      }

    },
    tabChange(index, src) {
      for (var i = 0; i < this.tabMenu.length; i++) {
        this.tabIndex = this.tabMenu[index].src;
        this.$store.state.tabIndex = this.tabMenu[index].src;
      }
    },
    countTime() {
//      console.log(this.$store.state.AllOfValue.ImDoctorInfo);
//      this.$toastMsg(this.$store.state.AllOfValue.ImDoctorInfo.buytime);
      //获取当前时间
      var date = new Date()
      var now = date.getTime()
      //设置截止时间
//      console.log(this.$store.state.AllOfValue.ImDoctorInfo.buytime);
//      var nowTime = this.$store.state.AllOfValue.ImDoctorInfo.buytime.split('.')[0];
//      console.log(nowTime);
//      var thisTime = nowTime;
//      thisTime = thisTime.replace(/-/g, '/');
//      var endDate = new Date(thisTime);
      var end=this.$store.state.AllOfValue.ImDoctorInfo.otime;
//      var end = endDate.getTime();
      //时间差
      var leftTime = end + 259200000  - now;
      //定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >0) {
        if(this.$store.state.AllOfValue.ImDoctorInfo.isOrder=='1'){
          this.isShow=1;
        }else if(
          this.$store.state.AllOfValue.ImDoctorInfo.isOrder=='2'&&this.$store.state.lastNum>0
        ){
          this.isShow=2;
        }else{
          this.isShow=0;
        }
//        else{
//          this.isShow=0;
//        }
        this.d = Math.floor(leftTime / 1000 / 60 / 60 / 24)//天数我没用到，暂且写上
        this.h = Math.floor((leftTime / 1000 / 60 / 60) % 24)+this.d*24
        this.m = Math.floor((leftTime / 1000 / 60) % 60)
        this.s = Math.floor((leftTime / 1000) % 60)
      }
      else{
        if(this.$store.state.AllOfValue.ImDoctorInfo.isOrder=='2'&&this.$store.state.lastNum>0){
            this.isShow=2;
          }else{
            this.isShow=0;
          }
      }
      //递归每秒调用countTime方法，显示动态时间效果
      setTimeout(this.countTime, 1000)
    },
  }
};



// WEBPACK FOOTER //
// ./src/views/im/index.vue